import { Workbox } from 'workbox-window';

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const worker = new Workbox('/service-worker.js');
    worker.register().catch(error => {
      console.warn('Service worker registration failed:', error);
    });
  });
}
